module.exports = __webpack_public_path__ + "img/completed.0cc07540.svg";